import { ApolloClient, ApolloLink, InMemoryCache, createHttpLink, } from "@apollo/client";
import { createAuthLink } from "aws-appsync-auth-link";
import { fetchAuthSession } from "aws-amplify/auth";

const url = process.env.REACT_APP_AWS_APPSYNC_GRAPHQL_ENDPOINT;
const region = process.env.REACT_APP_REGION;

// Use Amplify's fetchAuthSession instead of aws-sdk
const auth = {
  type: "AWS_IAM",
  credentials: async () => {
    try {
      const session = await fetchAuthSession();
      if (session.credentials) {
        return session.credentials;
      }
      throw new Error('No credentials available from session');
    } catch (error) {
      console.error('Error fetching auth session:', error);
      throw error;
    }
  },
};

const link = ApolloLink.from([
  // @ts-ignore
  createAuthLink({ url, region, auth }),
  // @ts-ignore
  createHttpLink({ uri: url }),
]);

const client = new ApolloClient({ link, cache: new InMemoryCache(), });

export async function getQueryUnAuth(query, data) {
  try {
    const response = await client.query({ variables: { ...data }, query: query, });
    return response;
  } catch (e) {
    console.error("ERROR AT QUERY " + e);
  }
}

export async function getQuery(query, data) {
  try {
    const res = await client.query({ query: query, data: { ...data } });
    return res;
  } catch (e) {
    console.error("ERROR AT QUERY " + e);
  }
}

export async function postMutationUnAuth(query, data) {
  try {
    const response = await client.mutate({ variables: { data }, mutation: query, });
    return response;
  } catch (e) {
    console.error("ERROR AT MUTATION " + e);
  }
}
export default client;
